export default "__VITE_ASSET__CktA7HBt__"